/*
 * @Author: ljs 2801931237@qq.com
 * @Date: 2023-07-12 13:52:59
 * @LastEditors: ljs 2801931237@qq.com
 * @LastEditTime: 2023-08-15 19:24:51
 * @FilePath: \飞行导航仪-企业-新vue-新mars3d\src\api\model\playback.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import config from "@/config"
import http from "@/utils/request"

export default {
	//飞参管理————数据列表
	playbackList: {
		url: `${config.MAIN_URL}/admin/fLightData/page`,
		name: "回放数据列表",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	//飞参管理——架次查询
	sorties: {
		url: `${config.MAIN_URL}/admin/fLightData/sorties`,
		name: "回放数据-架次",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	//飞参管理——获取筛选条件
	getAircriftShowType: {
		url: `${config.MAIN_URL}/admin/fLightData/airCrIfShowType`,
		name: "获取筛选条件",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	//飞参管理——飞参详情查询
	getFlightDatas: {
		url: `${config.MAIN_URL}/admin/fLightData/fLightDatas`,
		name: "回放数据获取-单机",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	//飞参管理——音频文件上传
	updateData: {
		url: `${config.MAIN_URL}/admin/fLightData/updateData`,
		name: "飞参管理——音频文件上传",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},

	//飞参管理——文件上传
	uploadFile: {
		url: `${config.MAIN_URL}/admin/fLightData/uploadFile`,
		name: "飞参管理——文件上传",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	//飞参管理——文件上传(OSS)
	ossUpload: {
		url: `${config.MAIN_URL}/api/v1/oss/annex`,
		name: "飞参管理——文件上传(oss)",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	//飞参回放——轨迹回放
	infoList: {
		url: `${config.MAIN_URL}/admin/fLightData/infoList`,
		name: "飞参回放——轨迹回放",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	liveLogin: {
		url: `${config.LIVE_URL}/api/v1/login`,
		name: "鉴权直播登录",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	liveHls: {
		url: `${config.LIVE_URL}/api/v1/record/query_daily`,
		name: "鉴权直播录像",
		get: async function (data) {
			return await http.get(this.url+ data);
		}
	},
	//飞参回放——剖面查询
	sectionView: {
		url: `${config.MAIN_URL}/admin/fLightData/sectionView`,
		name: "飞参回放——剖面查询",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	//飞参管理——飞参删除
	delData: {
		url: `${config.MAIN_URL}/admin/fLightData/delData`,
		name: "飞参管理——飞参删除",
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},

	//飞参管理——话音,舱音文件删除
	delFile: {
		url: `${config.MAIN_URL}/admin/fLightData/delFile`,
		name: "飞参管理——飞参删除",
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	//飞参管理——起降时间查询
	queryTime: {
		url: `${config.MAIN_URL}/admin/fLightData/queryTime`,
		name: "飞参管理——起降时间查询",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	querypath: {
		url: `${config.ADSB_URL}/api/playBack/nums/path`,
		name: "多机历史轨迹",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},


	date: {
		url: `${config.MAIN_URL}/user/api/month/days`,
		name: '获取那些时间有回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	playBackdate: {
		url: `${config.ADSB_URL}/api/playBack/days`,
		name: '获取那些时间有回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getsortie: {
		url: `${config.ADSB_URL}/api/playBack/nums/sortie`,
		name: '获取架次',
		get: async function (data = {}) {
			return await http.get(this.url+ data);
		},
	},
	playBacksectionView: {
		url: `${config.ADSB_URL}/api/playBack/nums/sectionView`,
		name: '获取架次',
		get: async function (data = {}) {
			return await http.get(this.url+data);
		},
	},

	list: {
		url: `${config.MAIN_URL}/user/api/company/monitoring`,
		name: '获取回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	queryCompany: {
		url: `${config.MAIN_URL}/admin/sysOperationLog/queryCompany`,
		name: '获取公司',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	listdata: {
		url: `${config.ADSB_URL}/api/playBack/data`,
		name: '获取回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	date_co: {
		url: `${config.MAIN_URL}/user/api/v2/month/days`,
		name: '全部企业那些时间有回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	list_co: {
		url: `${config.MAIN_URL}/user/api/v2/company/monitoring`,
		name: '根据企业获取回放列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	slog: {
		url: `${config.MAIN_URL}/user/api/monitoring/slog`,
		name: '获取回放轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},

}
